// src/components/DesignGrid.jsx
import React from "react";
import { socialMediaPosts } from "../designData";
import DesignCard from "./DesignCard/DesignCard";

const SocialMediaPosts = () => {
    return (
        <div>
            {socialMediaPosts.map((post) => (
                <DesignCard key={post.id} post={post} />
            ))}
        </div>
    );
};

export default SocialMediaPosts;